import { Component } from '@angular/core';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss',
  standalone: false,
})
export class NoDataComponent {}
